module.exports = __webpack_public_path__ + "static/media/sub_com_tutor_cent.6ffb552f.jpg";